type FullscreenImageSizeParams = {
  aspectRatio: number;
  hasThumbnails: boolean;
  viewportWidth: number;
  viewportHeight: number;
};

const SQUARE_RATIO_TOLERANCE = 0.03;

export const isRectangularImage = (aspectRatio: number) =>
  Number.isFinite(aspectRatio) &&
  aspectRatio > 0 &&
  Math.abs(aspectRatio - 1) > SQUARE_RATIO_TOLERANCE;

export const getFullscreenImageSize = ({
  aspectRatio,
  hasThumbnails,
  viewportWidth,
  viewportHeight,
}: FullscreenImageSizeParams) => {
  if (
    !isRectangularImage(aspectRatio) ||
    viewportWidth <= 0 ||
    viewportHeight <= 0
  ) {
    return null;
  }

  const isDesktop = viewportWidth >= 640;
  const horizontalPadding = isDesktop ? 48 : 24;
  const verticalPadding = hasThumbnails
    ? isDesktop
      ? 184
      : 190
    : isDesktop
      ? 96
      : 112;
  const maxWidth = Math.max(0, viewportWidth - horizontalPadding);
  const maxHeight = Math.max(0, viewportHeight - verticalPadding);
  const width = Math.min(maxWidth, maxHeight * aspectRatio);
  const height = width / aspectRatio;

  return {
    width: `${Math.floor(width)}px`,
    height: `${Math.floor(height)}px`,
  };
};
